import { NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'grid-filter-layout',
    template: ` <div class="nova-base-filter-cell-wrapper {{ class }}">
        @if (useQuickFilter) {
            <div class="quick-filter">
                <ng-container [ngTemplateOutlet]="quickFilter"></ng-container>
            </div>
        }
        <div class="popup-filter">
            <ng-container [ngTemplateOutlet]="popupFilter"></ng-container>
        </div>
    </div>`,
    styleUrls: ['./base-filter-cell-layout.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet]
})
export class GridFilterLayoutComponent {
    @Input() class = '';
    @Input() useQuickFilter = true;

    @ContentChild('quickFilter') quickFilter: TemplateRef<any>;
    @ContentChild('popupFilter') popupFilter: TemplateRef<any>;
}
